// extracted by mini-css-extract-plugin
export var chevronIcon = "_8q-2";
export var teamName = "_8q-1";
export var teamSwitcherButton = "_8q-0";